import React, { useState, useEffect, useRef } from "react";
import { useNavigate, Link } from "react-router-dom";
import Button from "../component/button/Button";
import ButtonLoad from "../component/button/ButtonLoad";
import InputOutline from "../component/input/InputOutline";
import AlertFailed from "../component/alert/AlertFailed";
import logo from "../img/logo.svg";
import { urlApi } from "../setting/Url";
import VerifyOtp from "./VerifyOtp";
import { HiOutlineEye } from "react-icons/hi2";
import { HiOutlineEyeOff } from "react-icons/hi";
import BaseLayout from "../layouts/BaseLayout";
import { Checkbox, Input } from "@heroui/react";

const Register = () => {
    const formRegister = useRef(null);

    let navigate = useNavigate();

    const [data, setData] = useState({
        namaLengkap: "",
        email: "",
        noHp: "",
        username: "",
        password: "",
        konfPassword: "",
        layanan: true,
    });

    const [kebijakanPrivasi, setKebijakanPrivasi] = useState(false);

    const [errors, setErrors] = useState({});

    const [modalVerifyOtp, setModalVerifyOtp] = useState(false);
    const [showPassword, setShowPassword] = useState({
        password: false,
        konfPassword: false,
    });
    const [loadButton, setLoadButton] = useState(false);
    const [showNotif, setShowNotif] = useState(null);
    const [msgNotif, setMsgNotif] = useState({
        messageResponse: "",
        messageApi: "",
    });

    const handleChange = (e) => {
        const { name, type, value, checked } = e.target;
        setData({
            ...data,
            [name]: type === "checkbox" ? (checked ? value : "") : value,
        });

        // reset error hanya di field yang sedang diketik
        setErrors((prev) => {
            const newErrors = { ...prev };
            delete newErrors[name];
            return newErrors;
        });
    };

    const SendOtpCode = async () => {
        try {
            let response = await fetch(`${urlApi}/api/pelanggan/send-otp`, {
                method: "POST",
                body: JSON.stringify({
                    nomor_hp: data.noHp,
                }),
            });

            let getResponse = await response.json();

            console.log(getResponse);
        } catch (error) {}
    };

    const submitFormRegister = async (e) => {
        e.preventDefault();

        setLoadButton(true);

        const dataRegister = {
            ...data,
            layanan: kebijakanPrivasi ? "Setuju" : "",
        };

        try {
            const response = await fetch(
                `${urlApi}/api/pelanggan/validate-user`,
                {
                    method: "POST",
                    body: JSON.stringify(dataRegister),
                }
            );

            const dataResponse = await response.json();

            if (dataResponse.status === "200") {
                setModalVerifyOtp(dataResponse.success);
                SendOtpCode();
            }

            if (response.status == 500) {
                const messageData = {
                    messageResponse: "Server Sedang Error",
                    messageApi: "Anda gagal mendaftar!",
                };

                setLoadButton(false);

                setShowNotif(false);

                setMsgNotif(messageData);
            }

            if (!response.ok) {
                // error dari server (misalnya validasi gagal, status 400)
                throw { status: response.status, dataResponse };
            }
        } catch (err) {
            console.log("Error terjadi:", err);

            if (err.status === 400 && err.dataResponse?.messages) {
                // error validasi dari backend
                setErrors(err.dataResponse.messages);
            } else {
                alert(
                    "Terjadi kesalahan: " +
                        (err.dataResponse?.message || err.message)
                );
            }
        } finally {
            setLoadButton(false);
        }
    };

    // Fungsi untuk toggle password atau konfPassword secara dinamis
    const toggleVisibility = (field) => {
        setShowPassword((prevState) => ({
            ...prevState, // Salin state sebelumnya
            [field]: !prevState[field], // Toggle nilai berdasarkan field yang dipilih
        }));
    };

    return (
        <div className="w-full bg-gradient-to-tr from-yellow_m-200 to-orange-100 h-screen flex justify-center relative">
            <div className="w-full h-screen bg-white/55 absolute bottom-0 rounded-3xl shadow-2xl px-[50px] flex flex-col justify-center">
                <div className="flex flex-col mt-5 mb-8">
                    <h2 className="box-login__title">Daftar</h2>
                </div>
                <div className="flex flex-col justify-around">
                    <form ref={formRegister} onSubmit={submitFormRegister}>
                        {/* <div className="mb-2">
                            <label htmlFor="Nama" className="label-login">
                                Nama Lengkap
                            </label>
                            <InputOutline
                                type="text"
                                name="namaLengkap"
                                change={handleChange}
                            ></InputOutline>
                            {}
                        </div> */}
                        <div className="mb-2">
                            <Input
                                label="Nama Lengkap"
                                name="namaLengkap"
                                classNames={{
                                    input: [
                                        "text-medium",
                                        "text-black_m-300",
                                        "placeholder:text-sm",
                                    ],
                                    inputWrapper:
                                        "pt-7 group-data-[focus=true]:outline-none group-data-[focus=true]:ring-0 group-data-[focus=true]:border-transparent",
                                    label: "mb-5",
                                }}
                                placeholder="Masukan Nama Kamu"
                                type="text"
                                size="lg"
                                isRequired
                                onChange={handleChange}
                                isInvalid={!!errors.namaLengkap}
                                errorMessage={errors.namaLengkap}
                                // validate={(value) => {
                                //     if (value.length === 0) {
                                //         return "Nomor WA tidak boleh kosong";
                                //     }
                                // }}
                            />
                        </div>
                        {/* <div className="mb-2">
                            <label htmlFor="no_hp" className="label-login">
                                No HP/WA
                            </label>
                            <InputOutline
                                type="number"
                                name="noHp"
                                change={handleChange}
                            ></InputOutline>
                        </div> */}
                        <div className="mb-2">
                            <Input
                                label="Nomor WA"
                                name="noHp"
                                classNames={{
                                    input: [
                                        "text-medium",
                                        "text-black_m-300",
                                        "placeholder:text-sm",
                                    ],
                                    inputWrapper:
                                        "pt-7 group-data-[focus=true]:outline-none group-data-[focus=true]:ring-0 group-data-[focus=true]:border-transparent",
                                    label: "mb-5",
                                }}
                                placeholder="Masukan Nomor WA-mu"
                                type="text"
                                size="lg"
                                isRequired
                                onChange={handleChange}
                                isInvalid={!!errors.noHp}
                                errorMessage={errors.noHp}
                                // validate={(value) => {
                                //     if (value.length === 0) {
                                //         return "Nomor WA tidak boleh kosong";
                                //     }
                                // }}
                            />
                        </div>
                        {/* <div className="mb-2">
                            <label htmlFor="password" className="label-login">
                                Password
                            </label>
                            <div className="relative">
                                <InputOutline
                                    type={
                                        showPassword.password
                                            ? "text"
                                            : "password"
                                    }
                                    name="password"
                                    change={handleChange}
                                ></InputOutline>
                                <button
                                    type="button"
                                    className="absolute text-xl top-2.5 right-3"
                                    onClick={() => toggleVisibility("password")}
                                >
                                    {showPassword.password ? (
                                        <HiOutlineEye />
                                    ) : (
                                        <HiOutlineEyeOff />
                                    )}
                                </button>
                            </div>
                        </div> */}
                        <div className="mb-2">
                            <Input
                                label="Password"
                                name="password"
                                classNames={{
                                    input: "text-medium placeholder:text-sm",
                                    inputWrapper:
                                        "pt-7 group-data-[focus=true]:outline-none group-data-[focus=true]:ring-0 group-data-[focus=true]:border-transparent",
                                    label: ["mb-5"],
                                }}
                                placeholder="Masukan Password"
                                type={
                                    showPassword.password ? "text" : "password"
                                }
                                size="lg"
                                isRequired
                                onChange={handleChange}
                                isInvalid={!!errors.password}
                                errorMessage={errors.password}
                                // validate={(value) => {
                                //     if (value.length === 0) {
                                //         return "Password tidak boleh kosong";
                                //     }
                                // }}
                                endContent={
                                    <button
                                        type="button"
                                        className="text-xl"
                                        onClick={() =>
                                            toggleVisibility("password")
                                        }
                                    >
                                        {showPassword.password ? (
                                            <HiOutlineEyeOff className="size-6 text-default-600" />
                                        ) : (
                                            <HiOutlineEye className="size-6 text-default-600" />
                                        )}
                                    </button>
                                }
                            />
                        </div>
                        {/* <div className="mb-2">
                            <label
                                htmlFor="konf_password"
                                className="label-login"
                            >
                                Konfirmasi Password
                            </label>
                            <div className="relative">
                                <InputOutline
                                    type={
                                        showPassword.konfPassword
                                            ? "text"
                                            : "password"
                                    }
                                    name="konfPassword"
                                    change={handleChange}
                                ></InputOutline>
                                <button
                                    type="button"
                                    className="absolute text-xl top-2.5 right-3"
                                    onClick={() =>
                                        toggleVisibility("konfPassword")
                                    }
                                >
                                    {showPassword.konfPassword ? (
                                        <HiOutlineEye />
                                    ) : (
                                        <HiOutlineEyeOff />
                                    )}
                                </button>
                            </div>
                        </div> */}
                        <div className="mb-2">
                            <Input
                                label="Konfirmasi Password"
                                name="konfPassword"
                                classNames={{
                                    input: "text-medium placeholder:text-sm",
                                    inputWrapper:
                                        "pt-7 group-data-[focus=true]:outline-none group-data-[focus=true]:ring-0 group-data-[focus=true]:border-transparent",
                                    label: ["mb-5"],
                                }}
                                placeholder="Masukan Konfirmasi Password"
                                type={
                                    showPassword.konfPassword
                                        ? "text"
                                        : "password"
                                }
                                size="lg"
                                isRequired
                                onChange={handleChange}
                                isInvalid={!!errors.konfPassword}
                                errorMessage={errors.konfPassword}
                                // validate={(value) => {
                                //     if (value.length === 0) {
                                //         return "Password tidak boleh kosong";
                                //     }
                                // }}
                                endContent={
                                    <button
                                        type="button"
                                        className="text-xl"
                                        onClick={() =>
                                            toggleVisibility("konfPassword")
                                        }
                                    >
                                        {showPassword.konfPassword ? (
                                            <HiOutlineEyeOff className="size-6 text-black_m-400" />
                                        ) : (
                                            <HiOutlineEye className="size-6 text-black_m-400" />
                                        )}
                                    </button>
                                }
                            />
                        </div>
                        {/* <div className="flex items-center my-4">
                            <div className="flex items-center h-5">
                                <input
                                    type="checkbox"
                                    name="layanan"
                                    id="layanan"
                                    value="Setuju"
                                    onChange={handleChange}
                                    className="w-3 h-3 bg-black_m-100 rounded border border-black_m-200 focus:ring-3 focus:ring-black_m-300"
                                />
                            </div>
                            <label
                                htmlFor="layanan"
                                className="ml-2 text-[11px] font-medium text-black_m-300"
                            >
                                Kebijakan Privasi & Ketentuan Layanan
                            </label>
                        </div> */}
                        {<div className="my-3">
                            <Checkbox
                                classNames={{
                                    label: "text-[13px] text-default-600",
                                }}
                                color="warning"
                                size="md"
                                isSelected={!!kebijakanPrivasi}
                                onValueChange={setKebijakanPrivasi}
                                isRequired
                            >
                                Kebijakan Privasi & Ketentuan Layanan
                            </Checkbox>
                        </div>}
                        <Button loading={loadButton} type="submit">
                            Selanjutnya
                        </Button>
                    </form>
                </div>
            </div>
            {showNotif === false ? (
                <AlertFailed
                    text={msgNotif.messageResponse}
                    apiText={msgNotif.messageApi}
                    notif={setShowNotif}
                />
            ) : (
                ""
            )}
            <VerifyOtp
                data={data}
                modalVerifyOtp={modalVerifyOtp}
                setModalVerifyOtp={setModalVerifyOtp}
                SendOtpCode={SendOtpCode}
            />
        </div>
    );
};

export default Register;
